import React from 'react';
import { RevealOnScroll } from './RevealOnScroll';
const modules = [{
  label: 'Módulo 1',
  title: 'Tu cuerpo en transición',
  desc: 'Entiende qué pasa con tus hormonas (sin tecnicismos)'
}, {
  label: 'Módulo 2',
  title: 'Apaga los sofocos',
  desc: '12 alimentos y 3 rutinas que cambian todo'
}, {
  label: 'Módulo 3',
  title: 'Recupera tu sueño',
  desc: 'Rutina nocturna de 5 minutos comprobada'
}, {
  label: 'Módulo 4',
  title: 'Plan de 21 días',
  desc: 'Calendario imprimible día por día'
}];
const bonuses = ['+ Recetario de 30 desayunos hormonales ($17)', '+ Audio de meditación para dormir ($9)', '+ Lista de compras del supermercado ($7)'];
export function WhatYouGet() {
  return <section className="w-full bg-pinkLight px-5 py-10 md:py-16" aria-labelledby="get-heading" data-id="element-213">
      <div className="mx-auto max-w-container" data-id="element-214">
        <h2 id="get-heading" className="font-serif text-[24px] font-medium text-wine md:text-[28px]" data-id="element-215">
          Esto es lo que vas a recibir
        </h2>

        <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2" data-id="element-216">
          {modules.map((m, i) => <RevealOnScroll key={i} delay={i * 0.06} data-id="element-217">
              <article className="h-full rounded-[12px] bg-white p-4 md:p-5" data-id="element-218">
                <p className="text-[11px] font-medium uppercase text-rose" style={{
              letterSpacing: '0.5px'
            }} data-id="element-219">
                  {m.label}
                </p>
                <h3 className="mt-2 text-[16px] font-medium leading-snug text-wine" data-id="element-220">
                  {m.title}
                </h3>
                <p className="mt-1 text-[13px] leading-relaxed text-burgundy" data-id="element-221">
                  {m.desc}
                </p>
              </article>
            </RevealOnScroll>)}
        </div>

        {/* Bonus card */}
        <RevealOnScroll delay={0.1} data-id="element-222">
          <div className="mt-6 rounded-[12px] bg-wine p-5 text-white md:p-6" data-id="element-223">
            <p className="label-caps text-[12px] text-pinkLight" data-id="element-224">
              <span aria-hidden="true" data-id="element-225">🎁</span> Bonos gratis (hoy)
            </p>
            <ul className="mt-4 flex flex-col gap-2" data-id="element-226">
              {bonuses.map((b, i) => <li key={i} className="text-[14px] text-cream/95" data-id="element-227">
                  {b}
                </li>)}
            </ul>
            <div className="mt-5 border-t border-white/15 pt-4 text-[14px]" data-id="element-228">
              <span className="text-cream/80" data-id="element-229">Valor real total: </span>
              <span className="line-through text-cream/70" data-id="element-230">$60</span>
              <span className="mx-2" data-id="element-231">—</span>
              <span className="text-pinkLight" data-id="element-232">Tu inversión hoy: </span>
              <span className="font-semibold text-white" data-id="element-233">$10</span>
            </div>
          </div>
        </RevealOnScroll>
      </div>
    </section>;
}